import { ISetGoalPayload } from "features/onboarding/types"

export enum IDailyCaloriesMode {
  INTAKE = "INTAKE",
  REMAINING = "REMAINING",
}

export type IProfileGender = "NON_BINARY" | "MALE" | "FEMALE"
interface userPreferences {
  dailyCaloriesMode: IDailyCaloriesMode
}

export interface IUpdateBodyAndUnitPayload {
  body?: IBody
  bodyDisplayUnits?: IBodyDisplayUnits
}
export interface IChangeBodyAndGoalPayload {
  changeGoalPayload: ISetGoalPayload
  bodyDisplayUnits?: IBodyDisplayUnits
}
export interface IProfile {
  name: string
  profile: {
    gender?: IProfileGender
    birthedOn: string
  }
}

export interface IGetProfileState {
  profile?: IProfile
  getProfileLoading: boolean
  getProfileFailed: any
}

export interface IBody {
  weight: number
  height: number
}

export type IBodyDisplayUnits = "METRIC" | "IMPERIAL"

export interface IGetBodyState {
  body: IBody
  getBodyLoading: boolean
  getBodyFailed: any
}
export interface IUpdateBodyAndUnitsState {
  updateBodyAndUnitsLoading: boolean
  updateBodyAndUnitsFailed: any
  updateBodyAndUnitsSuccess: any
}

export interface IGetBodyDisplayUnitsState {
  bodyDisplayUnits: IBodyDisplayUnits
  getBodyDisplayUnitsLoading: boolean
  getBodyDisplayUnitsFailed: any
}
export interface IUpdateBodyDisplayUnitsState {
  updateBodyDisplayUnitsLoading: boolean
  updateBodyDisplayUnitsFailed: any
  updateBodyDisplayUnitsSuccess: any
}

export interface IUserMeasurement {
  measurementId: string
  isArchived: boolean
  measuredAt: string
}

export interface IGetLatestUserScanState {
  latestUserScan?: IUserMeasurement
  lastMeasurementWeight?: number
  getLatestUserScanLoading: boolean
  getLatestUserScanFailed: any
}

export interface IChangeGoalState {
  changeGoalLoading: boolean
  changeGoalFailed: any
  changeGoalSuccess: any
}

export interface IManualUpdateGoalState {
  manualUpdateGoalLoading: boolean
  manualUpdateGoalFailed: any
  manualUpdateGoalSuccess: any
}
export interface IProfileState
  extends IGetProfileState,
    IGetBodyState,
    IUpdateBodyAndUnitsState,
    IGetBodyDisplayUnitsState,
    IUpdateBodyDisplayUnitsState,
    IChangeGoalState,
    IManualUpdateGoalState,
    IGetLatestUserScanState {
  userPreferences: userPreferences
  refreshCount: number
}

export interface IImperialDisplayedHeight {
  feet: number
  inches: number
}

export interface IManualUpdateGoalPayload {
  caloriePerDay: number
  pfcBalance: {
    protein: number
    fat: number
    carb: number
  }

  pfc: {
    protein: number
    fat: number
    carb: number
  }
}
